import React from "react";
import accountingYearHomeTwo from "../../../assets/img/accounting_year_home_2.png";
import { useIntl } from "react-intl";
import InputsCreateAccYear from "./inputsCreateAccYear";

const CreateAccountingYear = ({companyName, startDate, setStartDate, endDate, setEndDate}) => {

  const titleFirstRow = useIntl().formatMessage({ id: "accountingYear.createTitleFirst" },  { companyName: companyName });
  const titleSecondRow = useIntl().formatMessage({ id: "accountingYear.createTitleSecond" },  { companyName: companyName });
  const description = useIntl().formatMessage({id: "accountingYear.createDescription"});

  return (
    <div className="create-acc-year-container" style={{backgroundImage: `url(${accountingYearHomeTwo})`}}> 
      <div className="data-container">
        <h3 className="title">
          {titleFirstRow}
        </h3>
        <h3 className="title">
          {titleSecondRow}
        </h3>
        <p className="description">
          {description}
        </p>
        <div className="input-containers">
          <InputsCreateAccYear
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateAccountingYear;